import { createFileRoute } from '@tanstack/react-router';
import { NeedsAttentionPage } from '@pages/needs-attention';

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    /** Hide the persistent "My Groups" rail — full-width page content. */
    hideRail?: boolean;
  }
}

export const Route = createFileRoute('/_authenticated/needs-attention')({
  staticData: { hideRail: true },
  component: NeedsAttentionPage,
});
